angular = require('angular')
class ReportFactory
  @$injector: ['RestfulResource', '$http','config']
  constructor: (RestfulResource, $http, config)->    
    url = "#{config.api.url}/reports/"    
    actions = {}
    Report = new RestfulResource("#{url}/:_id", {_id: "@_id"}, actions)      
    Report.prototype.$assignDevice = (device)->
      exist = false
      @records ?= []
      @records.forEach (org)->
        if org.device?._id is device._id
          exist = true
      if not exist
        @records.push
          device: device
   
    return Report
module.exports = ReportFactory




// WEBPACK FOOTER //
// ./src/component/report/report.coffee